<template>
    <div class="scale-dialog">
        <el-dialog v-model="dialogTableVisible" title="设置" width="35%" center>
            <!--  -->
            <el-form :model="form" label-width="auto" size="medium" style="margin: 20px auto 0;width: 80%;" v-if="isShow">
            <el-form-item label="请输入管理密码:">
              <el-input v-model="form.pass" type="password" class="custom-input"   style="width: 100%;"    >
              </el-input>
            </el-form-item>
            </el-form>
        <template v-else>
          <!-- 去皮选项卡 -->
          <el-space wrap  style="width: 100%">
            <div class="tabs-item" v-for="(item, index) in tabList" :key="index" :class="{active: currentIndex-1==index}" @click="handleClick(index+1)">{{item.label}}</div>
            <el-checkbox  v-model="form.checked"  label="允许自定义容器" size="enum" />
          </el-space>
          <el-form :model="form" label-width="auto"  size="medium" class="custom-form" style="margin-top: 20px;">
            <el-form-item label="容器重量:">
              <div class="flex" style="width:100%">
              <el-input v-model="form.weigth" style="width: 55%;margin-right:15px" disabled>
                 <template #append>公斤</template>
                </el-input>
                <el-button size="medium"  @click="confirm">保存</el-button>
              </div>
            </el-form-item>
        </el-form>

    </template>
        <template #footer v-if="isShow">
          <el-button type="primary" size="medium" style="width:20%" @click="confirm(1)">确认</el-button>
        </template>
    </el-dialog>
    </div>
  </template>
  <script lang="ts" setup>
  import { reactive, ref } from 'vue'
  import { ElMessage } from "element-plus";
  import { defineExpose } from 'vue';
  import { getUserConfigValue,saveUserConfig,validPassword } from "@/api/setting.js";
  //是否显示弹框
  const dialogTableVisible = ref(false)
  // 表单数据
  const form=ref({
    checked:true,
    weigth:0,
    pass:''
  })

  // 选项卡
  const tabList=[{label:'黑色框',value:'Black'},{label:'蓝色框',value:'Blue'},
  {label:'红色框',value:'Red'},{label:'黄色框',value:'Yellow'},{label:'青色框',value:'Cyan'},
  {label:'紫色框',value:'Purple'},{label:'绿色框',value:'Green'}
]
  // 当前选中的选项卡
  let currentIndex = ref(1)
  // 当前弹框是出仓还是入仓或退仓
  let warehouseType = ref(0)
  let setTiem: any=null;
  // 是否显示管理密码
const isShow=ref(false)

//   确认密码
  const confirm = (type:number) => {
    if (type === 1) {
      if(!form.value.pass)return ElMessage.warning('请输入管理密码')
      // 密码验证
      validPassword({password:form.value.pass}).then((res: any) => {
         if (res.code === 200) {
            openCustom()
         } else {  
           ElMessage.error(res.msg)
         }
      })
     
    }else{
      // const val=form.value.weigth||0
      // const selectObj=tabList[currentIndex.value - 1]||{}
      // let colorVal=selectObj.value
      // script.getEnumu(colorVal)
      saveCustom()
    }

}

// 保存自定义容器
const saveCustom = () => {
  const configType=warehouseType.value==0?'add_warehouse_tare':warehouseType.value==1?'reduce_warehouse_tare':warehouseType.value!=2?'process_tare':""
  const configKey='scale_custom_container';
  const configValue=form.value.checked?1:0;
  let data={configType,configKey,configValue,id:form.value.id||'',configName:'允许自定义容器',operationType:'1'}
  saveUserConfig(data).then((res: any) => {
    if (res.code === 200) {
      ElMessage.success(res.msg)
      close()
    } else {
      ElMessage.error(res.msg)
    }
    
  })
}

  //复选 选项卡点击
  const handleClick = (index: number) => {
    currentIndex.value = index
  }
  
  // 打开弹框
  const open = (data: any,type:number) => {
    warehouseType.value = type
    dialogTableVisible.value = true
    isShow.value=true
  }

  // 打开设置自定义弹框
  const openCustom = () => {
    getCustomContainer()
    isShow.value = false
    clearInterval(setTiem);
    // 开启监听
    script.startSerialPortListerning()
    getWeight()
  }
  
  // 关闭弹框
  const close = () => {
    dialogTableVisible.value = false
    // const val=script.setEnumu(1,0)||0
    form.value={
      checked:true,
      weigth:0,
      pass:''
    }
    currentIndex.value = 1
    clearInterval(setTiem);
    // 停止监听
    script.stopSerialPortListerning()
  }
  // 获取重量
  // 每200 刷新秤端值
const getWeight = () => {
  setTiem = setInterval(() => {
    const weight = script.getWeight(); //getFloat(script.getWindowName());
    if (form.value.weigth !== weight) {
      form.value.weigth = weight;
    }
  }, 200);
  return setTiem;
};

// 查询是否有自定义容器
const getCustomContainer = () => {
  // warehouseType.value 1 出仓 0 入仓 2 退仓 3、4加工
  const configType=warehouseType.value==0?'add_warehouse_tare':warehouseType.value==1?'reduce_warehouse_tare':warehouseType.value!=2?'process_tare':""
   getUserConfigValue({configType,configKey:'scale_custom_container'}).then((res: any) => {
    const data = res.data||{};
    form.value['checked'] = data&&data.configValue==1?true:false;
    form.value.id =data.id||'';
    console.log(form.value);
    
   })
}
const getFloat = function (v) {
      if (typeof v == "string") {
        const str = v.split(/[\t\r\f\n\s]*/g).join("");
        var regEx = /[^\d|^\.|^\-]/g;
        const num = str.replace(regEx, "");
        return parseFloat(num);
      }
    };

// 设置自定义容器
  
  defineExpose({
    open,
  })
  </script>
  <style  scoped>
  >>>.custom-form .el-input-group__append{
    /* background: transparent; */
    padding: 0 5px;
    box-shadow: none;
  
  }
  >>>.custom-form .custom-input .el-input-group__append{
    background: transparent;
  }
  >>>.custom-form .el-input-group{
   border: 1px solid var(--el-border-color) ;
    border-radius: var(--el-input-border-radius);
  }
  >>>.custom-form .el-input__wrapper,>>>.custom-form .el-input.is-disabled .el-input__wrapper{
    box-shadow: none;
  }
  
  .tabs-item{
    /* width: calc(100% / 4); */
    min-width: 68px;
    text-align: center;
    border: 1px solid #ccc;
    padding:  8px 0;
    cursor: pointer;
    border-radius: 3px;
  
  }
  .active{
    background: #06AC53;
    border-color: #06AC53;
    color: #fff;
  }
  
  
  </style>
  <style>
   .scale-dialog .el-dialog__header .el-dialog__headerbtn{
    font-size: 30px ;
    height: auto;
  }
  .scale-dialog .el-dialog__header{
    border-bottom: 1px solid #ECECEC;
    margin: 0;
    padding-top: 10px;
  }
  .scale-dialog  .el-dialog--center .el-dialog__body{
    padding: 15px 16px 20px;
  }
  .scale-dialog .el-checkbox__input.is-checked .el-checkbox__inner{
    background: #06AC53;
    border-color: #06AC53;
    color: #06AC53;
  }
  .scale-dialog .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #06AC53;
  
  }
  .scale-dialog .hg-theme-default .hg-button{
    background: #e8e7e7;
  }
  .scale-dialog .hg-theme-default .hg-functionBtn{
    background: #d3d2d3;
  }
  .scale-dialog  .el-checkbox__label{
    padding-left: 5px;
  }
  </style>
  